import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useCouponsList() {
  // Use toast
  const toast = useToast();

  const refCouponListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // {key: 'id', label:'編號', class: 'sticky-column', sortable: true, tdClass:(value, key, item) => (item.is_active == 1)?null:'text-light'},
    {key: 'code', label:'優惠券號碼', class: 'sticky-column', sortable: true},
    {key: 'title', label:'優惠券名稱', class: 'sticky-column'},
    {key: "actions", label: "操作",  class: 'sticky-column'},
    {key: 'amount', label:'折扣金額',sortable: true, formatter: formatCurrency },
    {key: 'percentage', label:'折扣百分比',sortable: true},
    {key: 'customers', label:'限制可以使用優惠券的使用者'},
    {key: 'date_from', label:'從',sortable: true},
    {key: 'date_to', label:'到',sortable: true},
    {key: 'total_amount', label:'優惠券生效前必須達到的總金額',sortable: true, formatter: formatCurrency },
    {key: 'uses_per_coupon', label:'每張優惠券的使用次數',sortable: true},
    {key: 'uses_per_customer', label:'每個客戶的使用次數',sortable: true},
    {key: 'is_active', label: '狀態'},
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refCouponListTable.value
      ? refCouponListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refCouponListTable.value.refresh();
  };

  const couponsList = ref(null);

  const filter_customer_id = ref(null);

  watch(
    [currentPage, perPage, searchQuery,
      filter_customer_id,
    ],
    () => {
      refetchData();
    }
  );

  const fetchCoupons = (ctx, callback) => {
    store
      .dispatch("coupon/fetchCoupons", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        customer_id: filter_customer_id.value,
      })
      .then((response) => {
        const { coupons, total } = response.data;
        callback(coupons);
        totalRow.value = total;
        couponsList.value = coupons
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const customerOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        customers: true,
      })
      .then((response) => {
        customerOptions.value = response.data.customers;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchCoupons,
    tableColumns,
    perPage,
    totalRow,
    currentPage,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    dataMeta,
    couponsList,
    refCouponListTable,
    ability,
    refetchData,
    filter_customer_id,
    customerOptions,
  };
}
